import PureSegmentPicker from './SegmentPicker';
import withSelected from './components/withSelected';

export const SegmentPicker = withSelected(PureSegmentPicker);
export { PureSegmentPicker };
